var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',_vm._g(_vm._b({attrs:{"action":"#","on-change":_vm.handleUpload,"http-request":_vm.limits==1?_vm.uploadAction:_vm.uploadFiles,"auto-upload":false}},'el-upload',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }